import { render, staticRenderFns } from "./FieldRegion.vue?vue&type=template&id=05cdee02&"
import script from "./FieldRegion.vue?vue&type=script&lang=js&"
export * from "./FieldRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports